<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open) {
    <div class="panel-content">
      <form [formGroup]="form" class="form-photos">
        @if (this.companiesKeyValue?.length) {
          <div class="form-field-container">
            <div class="form-field-label">
              <p>{{ 'form.field.select_location' | transloco }}</p>
            </div>
            <lib-select
              [errors]="{ required: groupRequiredWhenNoDetails() }"
              [options]="companiesKeyValue"
              [value]="selectedCompanyLocation"
              (valueChange)="setLocation($event); detailsVisible = false"
            ></lib-select>
          </div>
          <mat-checkbox class="checkbox" (change)="toggleDetails($event.checked)" [checked]="detailsVisible">
            <span [innerHTML]="'form.field.other_address' | transloco"></span>
          </mat-checkbox>
        }
        <ng-container>
          <div class="details-container" [ngClass]="{ 'not-visible': !detailsVisible }">
            @for (field of locationFields; track field) {
              <div class="row">
                <div class="form-field-container col-12 col-sm-8">
                  <!-- Label -->
                  <div
                    class="form-field-label"
                    [ngClass]="{
                      required: isFormControlRequired(form.get(field)),
                    }"
                  >
                    {{ 'form.field.' + field | transloco }}
                  </div>
                  <!-- Label -->
                  @if (field !== 'country') {
                    <mat-form-field class="form-field" [floatLabel]="'auto'">
                      <input matInput [formControlName]="field" />
                      @if (form.get(field).invalid) {
                        <mat-error>
                          @if (form.get(field).errors.required) {
                            {{ 'form.error.required' | transloco }}
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                  } @else {
                    <lib-select
                      [value]="form.get(field).value"
                      [options]="keyValueCountries"
                      (valueChange)="form.get(field).setValue($event)"
                    ></lib-select>
                  }
                </div>
              </div>
            }
          </div>
        </ng-container>
      </form>
    </div>
  }
</div>
